import React, { useEffect, useState } from "react";
import Table from "../shared/table/Table";
import { FiEdit3, FiTrash2 } from "react-icons/fi";
import { useNavigate, useLocation } from "react-router-dom";
import { fetchData, fetchFormData, formatDateOnly } from "../../utils/options";
import { MdThumbDown, MdThumbUp } from "react-icons/md";
import topTost from "../../utils/topTost";
import Swal from "sweetalert2";

const PackageTable = () => {
  const [saveData, setSaveData] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  const fetchAllData = async () => {
    try {
      Swal.fire({
        title: "Loading...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const result = await fetchData("package-list", {}, "POST");

      if (result) {
        const data = result.data;
        setSaveData(data || []);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      Swal.close(); // hide loader
    }
  };

  const toggleStatus = async (Id) => {
    const formData = new FormData();
    formData.append("id", Id);

    const result = await fetchFormData(
      `toggle-package`,
      formData,
      "POST"
    );

    if (result && result.code === 200) {
      await fetchAllData();
      if (result && result.data.status === 1) {
        topTost({
          title: "Status updated successfully : Active",
          icon: "success",
        });
      } else {
        topTost({
          title: "Status updated successfully : Deactive",
          icon: "success",
        });
      }
    } else {
      console.error("Failed to toggle status:", result.message);
    }
  };

  const columns = [
    {
      accessorKey: "actions",
      header: () => "Actions",
      cell: ({ row }) => {
        const id = row.original.id;
        const is_active = row.original.status;
        return (
          <div className="hstack gap-2 justify-content-end">
            <span
              className="cursor-pointer"
              onClick={() => navigate(`/master/edit-package/${id}`)}
            >
              <FiEdit3 size={16} />
            </span>
            {is_active === 1 ? (
              <MdThumbUp
                className="cursor-pointer text-success"
                onClick={() => toggleStatus(id)}
              />
            ) : (
              <MdThumbDown
                className="cursor-pointer text-secondary"
                onClick={() => toggleStatus(id)}
              />
            )}
          </div>
        );
      },
      meta: {
        headerClassName: "width-30",
        exportable: false,
      },
    },
    {
      accessorKey: "price",
      header: () => "Price",
      cell: (info) => (
        <div
          style={{
            backgroundColor: "orange",
            color: "white",
            padding: "3px",
            borderRadius: "4px",
            textAlign: "center",
          }}
        >
          ₹ {info.getValue()}
        </div>
      ),
      defaultIsVisible: true,
    },
    {
      accessorKey: "package_name",
      header: () => "package name",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },

    {
      accessorKey: "validity_period",
      header: () => "validity period",
      cell: (info) => info.getValue(),
      defaultIsVisible: true,
    },

    {
      accessorKey: "created_at",
      header: () => "created at",
      cell: (info) => formatDateOnly(info.getValue()),
      defaultIsVisible: true,
    },
  ];

  useEffect(() => {
    fetchAllData();
  }, []);
  return (
    <>
      <Table data={saveData} columns={columns} />
    </>
  );
};

export default PackageTable;
